import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function ShoppingBag(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.393 3.748C10.058 3.262 10.917 3 12 3c1.083 0 1.942.262 2.607.748.663.484 1.088 1.158 1.362 1.901.264.717.397 1.528.464 2.351H18.5A1.5 1.5 0 0120 9.5v10a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 19.5v-10A1.5 1.5 0 015.5 8h2.067c.067-.823.2-1.634.464-2.35.274-.744.699-1.418 1.362-1.902zM7.514 9c-.014.496-.014.985-.014 1.447v.053a.5.5 0 001 0c0-.5 0-1.004.016-1.5h6.968c.015.496.016 1 .016 1.5a.5.5 0 001 0v-.053c0-.462 0-.95-.015-1.447H18.5a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5h2.014zm7.915-1H8.571c.062-.725.179-1.41.398-2.005.226-.614.551-1.102 1.013-1.44C10.442 4.22 11.082 4 12 4c.917 0 1.558.22 2.018.556.462.337.787.825 1.013 1.439.22.596.336 1.28.398 2.005z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(ShoppingBag);
export default ForwardRef;